/**
 *
 * @param inputDate
 * @returns string of type of type 'MMM Do, YYYY'
 */
export const mmmDoCommaSpaceYYYY = (inputDate: Date): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const day = inputDate.getDate();
  const month = months[inputDate.getMonth()];
  const year = inputDate.getFullYear();

  let daySuffix = 'th';

  if (day === 1 || day === 21 || day === 31) {
    daySuffix = 'st';
  } else if (day === 2 || day === 22) {
    daySuffix = 'nd';
  } else if (day === 3 || day === 23) {
    daySuffix = 'rd';
  }

  return `${month} ${day}${daySuffix}, ${year}`;
};

export const defaultFormatter = (date: Date) => {
  return date.toLocaleString('en-IN', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/**
 *
 * @param inputDate
 * @returns string of type of type 'YYYY-MM-DD HH:MM:SS'
 *
 *  eg input: Fri Dec 29 2023 13:00:00 GMT+0530 (India Standard Time)";
 *  eg output: "2023-12-29 13:00:00"
 */
export const yyyyMmDdHhMmSs = (date: Date) => {
  const inputDate = new Date(date);

  // Format the date in the desired output format
  const outputDateString =
    inputDate.toISOString().split('T')[0] +
    ' ' +
    inputDate.toTimeString().split(' ')[0];

  return outputDateString;
};

export const formateNumber = (number: number | string) => {
  const numberStr = number.toString();

  // Regular expression to format the number
  let lastThree = numberStr.slice(-3);
  const otherNumbers = numberStr.slice(0, -3);

  if (otherNumbers !== '') {
    lastThree = ',' + lastThree;
  }

  return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
};
